import { render, staticRenderFns } from "./PhoValidationObserver.vue?vue&type=template&id=70e2b6e8&lang=pug"
import script from "./PhoValidationObserver.vue?vue&type=script&lang=js"
export * from "./PhoValidationObserver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports